import React, { useState } from 'react';
import { ClipboardCheck, ChevronRight } from 'lucide-react';
import api from '@/utils/api';
import { Button } from '@/components/ui/button';
import { ptDate } from '@/utils/pioneerDates';
import { toast } from 'sonner';

// Trials Pioneiro atribuídos automaticamente pelo registo Google e ofertas antigas aceites — para o admin decidir.
export const PioneerReviewPanel = () => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const load = () => { setLoading(true); api.get('/admin/pioneer-review').then((r) => { setData(r.data); setOpen(true); }).finally(() => setLoading(false)); };
  const confirm = (id) => api.post(`/admin/trial-offers/${id}/confirm-legacy`).then(() => { toast.success('Oferta confirmada'); load(); });
  const g = data?.google_trials || [];
  const l = data?.legacy_offers || [];
  return (
    <div className="mb-6 rounded-xl border border-amber-200 bg-white p-4" data-testid="pioneer-review-panel">
      <div className="flex flex-wrap items-center gap-3">
        {data && <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} data-testid="pioneer-review-toggle"><ChevronRight className={`h-4 w-4 text-amber-600 transition-transform ${open ? 'rotate-90' : ''}`} /></button>}
        <ClipboardCheck className="h-4 w-4 text-amber-600" />
        <p className="flex-1 font-bold text-slate-900">Pioneiro por rever {data && <span className="font-normal text-sm text-slate-500">· {g.length} trial(s) automático(s) Google · {l.length} oferta(s) antiga(s) aceite(s)</span>}</p>
        <Button size="sm" variant="outline" onClick={load} disabled={loading} data-testid="pioneer-review-load">{data ? 'Actualizar' : 'Ver lista'}</Button>
      </div>
      {data && open && (
        <div className="mt-3 space-y-4 text-sm">
          <div data-testid="pioneer-review-google">
            <p className="mb-1 font-semibold text-slate-700">Trial automático (registo Google) — não foi retirado</p>
            {g.length === 0 ? <p className="text-slate-500" data-testid="pioneer-review-google-empty">Nenhuma empresa.</p> : g.map((t) => (
              <div key={t.employer_id} className="flex flex-wrap gap-3 border-t border-slate-100 py-1.5" data-testid={`pioneer-review-google-${t.employer_id}`}>
                <span className="font-semibold">{t.company_name || '—'}</span><span className="text-slate-500">{t.email}</span>
                <span className="font-mono">NIF {t.fiscal_nif || '—'}{t.nif_duplicate ? ' (duplicado)' : ''}</span>
                <span className="text-slate-500">{ptDate(t.created_at)} → {ptDate(t.expires_at)} · {t.status}</span>
              </div>
            ))}
          </div>
          <div data-testid="pioneer-review-legacy">
            <p className="mb-1 font-semibold text-slate-700">Aceite a partir de oferta antiga</p>
            {l.length === 0 ? <p className="text-slate-500" data-testid="pioneer-review-legacy-empty">Nenhuma oferta.</p> : l.map((o) => (
              <div key={o.id} className="flex flex-wrap items-center gap-3 border-t border-slate-100 py-1.5" data-testid={`pioneer-review-legacy-${o.id}`}>
                <span className="font-semibold">{o.company_name || '—'}</span><span className="text-slate-500">{o.prospect_email}</span>
                <span className="text-slate-500">aceite {ptDate(o.accepted_at)}</span>
                {o.legacy_confirmed_at
                  ? <span className="text-emerald-700" data-testid={`pioneer-review-confirmed-${o.id}`}>Confirmada {ptDate(o.legacy_confirmed_at)}</span>
                  : <Button size="sm" onClick={() => confirm(o.id)} data-testid={`pioneer-review-confirm-${o.id}`}>Confirmar</Button>}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
